import { memo } from "react"

import { Area } from "@/atoms"
import { TooltipGraph } from "./TooltipGraph"

import styles from "./HeaderDeploymentsTab.module.scss"

import type { getSensorsCount } from "@/pages/DeploymentsPage/application/useFiltersDeployments.selector"

export const BaselineUsageGraph = memo(
  function BaselineUsageGraphComponent(props: {
    averageBuckets?: ReturnType<typeof getSensorsCount>["averageBuckets"]
  }) {
    const config = {
      autoFit: true,
      height: 108,
      xField: "bucketStart",
      yField: "liveCount",
      legend: false as const,
      padding: [8, 0, 0, 0],
      xAxis: {
        label: null,
        line: null,
        tickLine: null,
        grid: null
      },
      yAxis: {
        label: null,
        grid: null
      },
      areaStyle: () => {
        return {
          fill: "l(270) 0:rgba(230, 247, 255, 0) 1:rgba(64, 169, 255, 1)"
        }
      }
    }

    return (
      <div className={styles.graphContainer}>
        <Area
          data={props.averageBuckets || []}
          tooltip={{
            customContent: (_, item) => {
              const { bucketStart, liveCount } = item?.[0]?.data || {}

              return (
                <TooltipGraph
                  count={liveCount}
                  label="Average"
                  timestamp={bucketStart}
                />
              )
            }
          }}
          {...config}
        />
      </div>
    )
  },
  (prevProps, nextProps) =>
    prevProps.averageBuckets === nextProps.averageBuckets
)
